// frontend/client/src/auth.js
import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadMe() {
      try {
        // package.json'da proxy: "http://localhost:8080" olduğu için
        // burada sadece /api/me yazmamız yeterli.
        const res = await fetch("/api/me", { credentials: "include" });

        if (res.status === 401) {
          setUser(null);
          setLoading(false);
          return;
        }

        const data = await res.json();
        if (data.ok && data.user) {
          const u = data.user;

          setUser({
            fullName: u.fullName || u.name || "",
            name: u.name || u.fullName || "",
            university: u.university || "",
            profileImageUrl: u.profileImageUrl || "",
            isAdmin: !!u.isAdmin,
            unreadMessages: u.unreadMessages || 0,
            winsenseRating: u.winsenseRating || 1200,
            winsenseRank: u.winsenseRank || ""
          });
        }
      } catch (err) {
        console.error("api/me error", err);
      } finally {
        setLoading(false);
      }
    }

    loadMe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
